import Aboutus from "./Aboutus.container";

export default Aboutus;
